(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-line-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-bundle-components')) {
    // The drawer HTML is replaced after every cart change, so which bundles
    // the shopper collapsed is remembered here, outside the elements.
    const collapsedLines = new Set()

    class CartBundleComponents extends HTMLElement {
      connectedCallback() {
        this.toggle(!collapsedLines.has(this.dataset.lineKey))
      }

      toggle(open = this.hidden) {
        const trigger = this.closest('[data-cart-line]')?.querySelector(
          '[data-cart-bundle-toggle]'
        )
        const label = trigger?.querySelector('[data-cart-bundle-toggle-label]')

        this.hidden = !open

        if (open) collapsedLines.delete(this.dataset.lineKey)
        else collapsedLines.add(this.dataset.lineKey)

        trigger?.setAttribute('aria-expanded', String(open))
        if (label) {
          label.textContent = open ? trigger.dataset.hideText : trigger.dataset.showText
        }
      }
    }

    customElements.define('cart-bundle-components', CartBundleComponents)

    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-cart-bundle-toggle]')

      if (trigger) document.getElementById(trigger.getAttribute('aria-controls'))?.toggle()
    })

    // Remembers which cart line the shopper is changing. The bundle product page
    // reads this key (see lyle-main-product.js) and replaces the line on add to bag.
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-cart-change-sizes]')

      if (!link) return

      try {
        sessionStorage.setItem(
          'lyle:bundle-change-sizes',
          JSON.stringify({ lineKey: link.dataset.lineKey, productId: link.dataset.productId })
        )
      } catch {
        // Storage can be blocked. The link still opens the product page.
      }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    let productCardTouchStartX = 0;
  let productCardTouchStartY = 0;

  function toggleProductCardSecondaryImage(card) {
    card.classList.toggle('product-card--show-secondary');
    card.dispatchEvent(new CustomEvent('product-card:image-toggle', {
      bubbles: true,
    }));
  }

  function showProductCardSecondaryImage(card) {
    card.classList.add('product-card--show-secondary');
    card.dispatchEvent(new CustomEvent('product-card:image-toggle', {
      bubbles: true,
    }));
  }

  function shouldRevealProductCardSecondaryImageOnClick(card) {
    if (card.classList.contains('product-card--show-secondary')) return false;

    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented) return;

    const image = event.target.closest('.product-card__primary-image, .product-card__secondary-image');
    const card = event.target.closest('[data-product-card]');

    if (
      image &&
      card?.querySelector('.product-card__secondary-image') &&
      shouldRevealProductCardSecondaryImageOnClick(card) &&
      !event.target.closest('[data-quick-view], [data-card-swatch], [data-card-size]')
    ) {
      event.preventDefault();
      showProductCardSecondaryImage(card);
    }
  });

  document.addEventListener('touchstart', event => {
    const thumbnail = event.target.closest('.product-card__thumbnail');

    if (!thumbnail || !event.touches.length) return;

    productCardTouchStartX = event.touches[0].clientX;
    productCardTouchStartY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', event => {
    if (event.defaultPrevented) return;

    const thumbnail = event.target.closest('.product-card__thumbnail');
    const card = event.target.closest('[data-product-card]');

    if (!thumbnail || !card || !event.changedTouches.length) return;

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - productCardTouchStartX;
    const deltaY = touch.clientY - productCardTouchStartY;

    if (
      Math.abs(deltaX) <= 35 ||
      Math.abs(deltaX) <= Math.abs(deltaY) ||
      !card.querySelector('.product-card__secondary-image')
    ) {
      return;
    }

    event.preventDefault();
    toggleProductCardSecondaryImage(card);
  }, false);
  } catch(e) { console.error(e); }
})();

})();
